export default (context, inject) => {
    const LOG_FLUSH_DELAY = 5000;

    let pendingLogs = [];
    let flushTimer = null;

    /**
     * Flushes any pending snippet log messages as a single collapsed
     * console group.
     *
     * Snippet lookups can fire dozens of times per render, so logs are
     * batched and only flushed once 5 seconds pass with no new log.
     *
     * @returns {void}
     */
    const flushLogs = () => {
        if (!pendingLogs.length) {
            return;
        }

        //eslint-disable-next-line no-console
        console.groupCollapsed('SNIPPETS');

        pendingLogs.forEach((message) => {
            //eslint-disable-next-line no-console
            console.warn(message);
        });

        //eslint-disable-next-line no-console
        console.groupEnd();

        pendingLogs = [];
    };

    /**
     * Queues a snippet log message, resetting the flush debounce timer.
     *
     * @param {string} message
     *
     * @returns {void}
     */
    const queueLog = (message) => {
        pendingLogs.push(message);

        clearTimeout(flushTimer);
        flushTimer = setTimeout(flushLogs, LOG_FLUSH_DELAY);
    };

    /**
     * Snippet shortcut.
     *
     * @param {string} key
     * @param {string} fallback
     *
     * @returns {string}
     */
    const snippet = function(key, fallback = '') {
        const locale = this.$store.state.locales.locales.find(({ code }) => code === this.$route.path.split('/')[1] ?? 'en')?.code ?? 'en';

        const snippetForLocale = this.$store.state.snippets[key]?.[locale];
        const defaultLocaleSnippet = this.$store.state.snippets[key]?.en;

        if (!snippetForLocale) {
            queueLog(`SNIPPETS - No snippet for key [${ key }] found for locale [${ locale }].`);

            if (locale !== 'en') {
                if (defaultLocaleSnippet) {
                    queueLog(`SNIPPETS - Falling back to default locale [en] for snippet key [${ key }].`);
                } else {
                    queueLog(`SNIPPETS - No default [en] locale value found for snippet key [${ key }].`);
                }
            }

            if (!defaultLocaleSnippet && fallback) {
                queueLog(`SNIPPETS - Using fallback for snippet with key [${ key }] and value: [${ fallback }].`);
            }

            if (!defaultLocaleSnippet && !fallback) {
                queueLog(`SNIPPETS - No fallback provided for snippet with key [${ key }].`);
            }
        }

        return snippetForLocale
            || defaultLocaleSnippet
            || fallback;
    };

    context.$snippet = snippet.bind({
        $store: context.app.store,
        $route: context.app.router.currentRoute,
    });
    inject('snippet', snippet);
};
